import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "facebook",
  "use": "facebook-usage",
  "viewBox": "0 0 24.995 24.844",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24.995 24.844\" id=\"facebook\">\n  <path id=\"facebook_Icon_awesome-facebook\" data-name=\"Icon awesome-facebook\" d=\"M25.558,13.06a12.5,12.5,0,1,0-14.45,12.347V16.673H7.933V13.06h3.175V10.307c0-3.132,1.865-4.862,4.72-4.862a19.234,19.234,0,0,1,2.8.244V8.763H17.049a1.806,1.806,0,0,0-2.036,1.952V13.06h3.466l-.554,3.613H15.013v8.734A12.5,12.5,0,0,0,25.558,13.06Z\" transform=\"translate(-0.563 -0.563)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol